'use strict';

var i18n = require('i18next');
var EditVpnRoutes = require('actions/vpn/routes/EditVpnRoutes');
var FormView = require('actions/vpn/routes/FormView');
var StaticView = require('actions/vpn/routes/StaticView');

/**
 * Action configuration for the VPN enable/disable action component.
 */
module.exports = {
  title: i18n.t('vpn.routes.title'),
  Model: EditVpnRoutes,
  FormView: FormView,
  TextView: StaticView,
};
